class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.notification.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this)),
    );
  }
  open() {
    this.notification.classList.add("animate", "active");
    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: !0 },
    );
    document.body.addEventListener("click", this.onBodyClick);
  }
  close() {
    this.notification.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }
  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      if (!sectionElement) return;

      if (section.id === "cart-icon-bubble") {
        const iconType = sectionElement.getAttribute("data-cart-icon-type");
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        if (iconType) {
          sectionElement.setAttribute("data-cart-icon-type", iconType);
        }
        const iconWrapper = sectionElement.querySelector(".svg-wrapper");
        if (iconWrapper && iconType) {
          const bagIcon = iconWrapper.querySelector(".cart-icon-bag");
          const cartIcon = iconWrapper.querySelector(".cart-icon-cart");
          const cartIconEmpty = iconWrapper.querySelector(".cart-icon-cart-empty");

          if (iconType === "bag") {
            if (bagIcon) bagIcon.style.display = "flex";
          } else {
            const cartEmpty = parsedState.item_count === 0;
            if (cartEmpty && cartIconEmpty) {
              cartIconEmpty.style.display = "flex";
            } else if (cartIcon) {
              cartIcon.style.display = "flex";
            }
          }
        }
      } else {
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });
    if (this.header) this.header.reveal();
    this.open();
  }
  getSectionsToRender() {
    return [
      { id: "cart-notification-product", selector: `[id="cart-notification-product-${this.cartItemKey}"]` },
      { id: "cart-notification-button" },
      { id: "cart-icon-bubble" },
    ];
  }
  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }
  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure ? disclosure.querySelector("summary") : null;
      this.close();
    }
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("cart-notification", CartNotification);